<template>
  <div id="dqwz">
    <div class="headerbox">
      <em @click="dialogTableVisible = true"><span><i class="el-icon-search"></i>搜索</span></em>
      <div class="leftbox">
         <div class="logo" @click="gotoindexbiaoqian"><img :src="logo" /></div>
         <dl class="navdl">
             <dt :class="dqon == index ? 'active' : ''" v-for="(item,index) in mcdatalist" v-if="item.state==1" :key="index" @click="gotopnav(index)">{{ item.name }}</dt>
            
         </dl>           
      </div>
    </div>

    <div :class="isshowblack ? 'blacknav' : 'blacknav blacknavhidden'">
      <em @click="dialogTableVisible = true"><span><i class="el-icon-search"></i>搜索</span></em>
      <div class="leftbox">
        <div class="logo" @click="gotoindexbiaoqian"><img :src="blogo" /></div>
        <dl class="navdl">
              <dt :class="dqon == index ? 'active' : ''" v-for="(item,index) in mcdatalist" v-if="item.state==1" :key="index" @click="gotopnav(index)">{{ item.name }}</dt>
              
        </dl>

      </div>

    </div>


    <el-dialog title="搜索" :visible.sync="dialogTableVisible">
        <div class="searchbox">
          <el-input v-model="searchtext" placeholder="请输入搜索关键字"></el-input>
          <el-button type="success" icon="el-icon-search" @click="gotoserch">搜索</el-button>
        </div>
        <div class="hotsearch">
          <dl>
            <dt>热门搜索：</dt>
            <dd>
              <span v-for="(item,index) in hotsearchlist" @click="gotokeyword(item)" :key="index">{{ item }}</span>
            </dd>
          </dl>  
          </div>

    </el-dialog>

  </div>
</template>

<script>
import { getmainclass} from "@/api/api";

export default {

  data() {
    return {
      logo: require("@/assets/images/logo.jpg"),
      blogo: require("@/assets/images/logo.jpg"),
      searchvalue:'',
      mcdatalist:[],
      dqon:0,
      isshowblack:false,
      dialogTableVisible: false,
      searchtext:'',
      hotsearchlist:["AI","AI工具","EXCEL","视频","配音","图片","图片生成","数据","运营工具","教程","简历","求职","新媒体","学习"]
    };
  },
  watch: {
    '$route.name'(newName, oldName) {
      // 当 $route.name 变化时执行的代码
      console.log('Route name changed from', oldName, 'to', newName);
      if(newName=='contact'){
        this.dqon = 50;
      }else if(newName=='search'){
        this.dqon = 80;
      }

    }
  },
  created(){
     this.$Loading.finish();
     this.gogetmainclass();
     //判断当前页面
     if(this.$route.name=='index'){
       this.dqon = 0;
     }else if(this.$route.name=='ai'){
       this.dqon = 1;
     }else if(this.$route.name=='design'){
       this.dqon = 2;
     }else if(this.$route.name=='selfmedia'){
       this.dqon = 3;
     }else if(this.$route.name=='programmer'){
       this.dqon = 4;
     }else if(this.$route.name=='student'){
       this.dqon = 5;
     }else if(this.$route.name=='operation'){
       this.dqon = 6;
     }else if(this.$route.name=='officework'){
       this.dqon = 7;
     }else if(this.$route.name=='business'){
       this.dqon = 8;
     }else if(this.$route.name=='ecommerce'){
       this.dqon = 9;
     }else if(this.$route.name=='cbecommerce'){
       this.dqon = 10;
     }else if(this.$route.name=='contact'){
       this.dqon = 50;
     }else if(this.$route.name=='search'){
       this.dqon = 80;
     }
  },
  mounted(){
    console.log('mcdata',this.mcdata);
    window.addEventListener("scroll", this.handleScroll);
  },
   beforeDestroy() {
    // 销毁组件时移除监听，防止内存泄漏
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods:{
    gotokeyword(item){
      this.searchtext = item;
      this.gotoserch();
    },
     handleScroll() {
      // 兼容获取滚动距离顶部的值（核心）
      const top =
        document.documentElement.scrollTop || document.body.scrollTop;
      
      // 赋值到 data 中
      this.scrollTop = top;

      // 业务逻辑：例如滚动超过 100px 做某事
      if (top > 200) {
        //console.log("滚动距离超过 100px 啦！");
        this.isshowblack = true;
      }else{
        this.isshowblack = false;
      }
    },
    gogetmainclass(){
      var that = this;
      var page=1,
        pageSize=20

      getmainclass(page,pageSize).then(res=>{
        console.log('res',res)
        that.mcdatalist = res.data.rows;
      })
    },
    //顶部导航选择
    gotopnav(index){
      this.dqon = index;
      console.log('this.dqon----------',this.dqon);
      //console.log('index',index);
      //console.log('this.mcdata',this.mcdata);
      if(this.mcdatalist[index].id==2){
        this.$router.push({
          name:'index'
        })
      }else if(this.mcdatalist[index].id==3){
        this.$router.push({
          name:'ai'
        })
      }else if(this.mcdatalist[index].id==5){
        this.$router.push({
          name:'design'
        })
      }else if(this.mcdatalist[index].id==4){
        this.$router.push({
          name:'selfmedia'
        })
      }else if(this.mcdatalist[index].id==8){
        this.$router.push({
          name:'programmer'
        })
      }else if(this.mcdatalist[index].id==13){
        this.$router.push({
          name:'student'
        })
      }else if(this.mcdatalist[index].id==15){
        this.$router.push({
          name:'operation'
        })
      }else if(this.mcdatalist[index].id==16){
        this.$router.push({
          name:'officework'
        })
      }else if(this.mcdatalist[index].id==17){
        this.$router.push({
          name:'business'
        })
      }else if(this.mcdatalist[index].id==18){
        this.$router.push({
          name:'ecommerce'
        })
      }else if(this.mcdatalist[index].id==19){
        this.$router.push({
          name:'cbecommerce'
        })
      }
    },
    gotoconact(){      
      this.dqon = 100;
      this.$router.push({
        name:'contact'
      })
    },

    gotoserch(){
        var that = this;  
        var searchtext = that.searchtext;
        if(searchtext==''){
          this.$message.error('请输入搜索关键字！');
        }else{
          this.$router.push({
            name:'search',
            query:{
              searchtext:searchtext
            }
          })

          that.dialogTableVisible = false;
          this.searchtext = '';


        }

    },
    gotoindexbiaoqian(){
      this.dqon = 0;
      this.$router.push({
        name:'index'
      })
    }
  }
};
</script>

<style  lang="scss" scoped>
.headerbox {
   min-width:1380px;
  height: 70px; box-shadow: 0 0 5px #ccc;width: 100%;z-index: 50;
  background: #fff;//background: #01a6ff; 
  em{float: right; font-style: normal; font-size:15px; cursor: pointer; color: #333; padding-right:55px; padding-top:20px;}
  em span i{ margin-right: 5px;}
  em span { font-size: 15px;}
  .leftbox{
      .logo{ width: 235px;
           display: flex; float: left; cursor: pointer;
           align-items: flex-start;padding-top:12px; padding-left:43px; padding-right: 25px;
           img{ width:150px;}
      }
      .navdl{ float: left; padding-left: 20px;
        dt{float: left; font-size:16px; color: #333; text-align: center; line-height: 60px; height: 60px; cursor: pointer; margin-left:25px;}
        dt.active{border-bottom: 3px solid #27c42f;}
        dd{ float: left; margin-top: 12px; position: relative; margin-left: 30px;
          input{
            width: 230px; height: 37px; border: 1px solid #ddd; border-radius: 30px;
            text-indent: 20px; font-size: 13px; outline: none;transition:0.5s;
          }
          .addinput{
            width: 300px; height: 37px; border: 1px solid #ddd;  border-radius: 30px;
            text-indent: 20px; font-size: 13px; outline: none;
          }
          span{ position: absolute; right: 15px; top:0px; font-size:22px; color: #666; cursor: pointer;}
         
        }
      }
  }
 
}



.blacknav{ height: 50px; background:rgba(255,255,255,1); top:0;left:0; width: 100%; position: fixed; z-index: 999; box-shadow: 0 2px 2px #ddd; min-width:1380px;}

.blacknav em{float: right; font-style: normal; font-size:15px; cursor: pointer; color: #333; padding-right:55px; padding-top:15px;}
.blacknav em span i{ margin-right: 5px;}
.blacknav em span { font-size: 15px;}


.blacknavhidden{ height: 50px; background:rgba(255,255,255,0.95); top:-200px;left:0; width: 100%; position: fixed; z-index: 999; box-shadow: 0 0 5px #ccc;}



.blacknav .logo{ width: 150px;  float: left; cursor: pointer;
           padding-top:8px; padding-left:63px;
           img{ width:110px;}
      }

.blacknav .navdl{ float: left; padding-left: 100px;
        dt{float: left; font-size:16px; color: #333; text-align: center; line-height: 50px; height: 50px; cursor: pointer; margin-left:25px;}
        dt.active{border-bottom: 3px solid #27c42f;}
        dd{ float: left; margin-top: 12px; position: relative; margin-left: 30px;
          input{
            width: 230px; height: 37px; border: 1px solid #27c42f; border-radius: 30px;
            text-indent: 20px; font-size: 13px; outline: none;transition:0.5s;
          }
          .addinput{
            width: 300px; height: 37px; border: 1px solid #ddd;  border-radius: 30px;
            text-indent: 20px; font-size: 13px; outline: none;
          }
          span{ position: absolute; right: 15px; top:0px; font-size:22px; color: #666; cursor: pointer;}
         
        }
      }

.searchbox{ display: flex; justify-content: left; align-items: center;}

.hotsearch{ padding-bottom: 20px;}

.hotsearch dl{}
.hotsearch dl dt{ font-size: 15px; color: #333; padding-top: 20px;}
.hotsearch dl dd{ font-size: 13px; color: #888; padding-top: 20px; overflow: hidden;}
.hotsearch dl dd span{ border: 1px solid #eee; float: left; padding: 8px 10px; margin-right: 10px; cursor: pointer; border-radius: 3px; margin-bottom: 20px;}


</style>

<style>
.ivu-loading-bar-inner-color-primary{ background-color: #ffa200;}
.el-input__inner:focus{ border-color:#aaa !important;}
</style>


// WEBPACK FOOTER //
// src/components/publish/headernav.vue